import _ from 'underscore';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';

const { TaxCertificateDeclineReasonType, TaxInfo, VatStatusEnum } = Constants;

export const { AccountMode } = Constants;

export const InputTaxFieldId = taxType => `TaxField_${taxType}`;

export const TaxOptionTypeKey = 'TaxOptionType';
export const TaxOptionTypeI18nKey = _TL_('Tax type');
export const TaxOptionTypesName = 'TaxTypeOptions';
export const SkipVatIdValidationTypeKey = TaxInfo.SkipVatIdValidation;
export const SkipVatIdValidationLabelKey = _TL_('This customer provided a local VAT registration number that has been approved by EMEA Tax.');
export const IsTaxExemptionCertVerifiedTypeKey = TaxInfo.IsTaxExemptionCertVerified;
export const IsTaxExemptionCertVerifiedLabelKey = _TL_('A valid VAT exemption certificate has been provided by the customer.');
export const IsIVAOrVATTaxPayerTypeKey = TaxInfo.IsIVAOrVATTaxPayer;
export const IsIVAOrVATTaxPayerPositiveLabelKey = _TL_('The customer has confirmed that they are an IVA/VAT taxpayer.');
export const IsIVAOrVATTaxPayerNegativeLabelKey = _TL_('The customer has confirmed that they are not an IVA/VAT taxpayer.');
export const IsWithholdingTaxExemptedTypeKey = TaxInfo.IsWithholdingTaxExempted;
export const IsWithholdingTaxExemptedPositiveLabelKey = _TL_('The customer has confirmed that the WHT exemption applies to them.');
export const IsWithholdingTaxExemptedNegativeLabelKey = _TL_('The customer has confirmed that the WHT exemption does not apply to them.');
export const InvalidVatIDKey = _TL_('Enter a valid VAT registration number without spaces.');
export const MaxLengthExceededKey = _TL_('Enter a value that is {{maxlength}} characters or less');
export const ReverseChargeDocumentAttestationKey = 'ReverseChargeDocumentAttestation';

export const TaxFormMode = {
  ViewMode: 'view',
  EditMode: 'edit',
};

export const FileMaxSizeMb = 20;
export const CertMaxSizeLimitation = FileMaxSizeMb * 1024 * 1024;
export const FileAllowedExtension = ['.pdf'];

export const ReverseChargeDocumentFileAllowedExtension = ['.doc', '.docx', '.pdf'];

export const ReverseChargeDocumentMaxSizeLimitation = FileMaxSizeMb * 1024 * 1024;

export const ReverseChargeDocumentTemplateFileGuid = '69776863-4838-4575-8578-51ef54820c29';

export const FileScenarioMapping = {
  CO: 'ColombiaTaxCert',
  AE: 'AETax',
  IL: 'ILTax',
  NO: 'NOTax',
  TR: 'TRTax',
  VN: 'VNTax',
  GE: 'GETax',
  TH: 'THTax',
  BD: 'BDTax',
  ID: 'IDTax',
  BY: 'BYTax',
  NG: 'NGTax',
  IS: 'ISTax',
  NC: 'NCTax',
  AL: 'ALTax',
  MD: 'MDTax',
  ZW: 'ZWTax',
  BH: 'BHTax',
  KH: 'KHTax',
  KE: 'KETax',
  SA: 'SATax',
  OM: 'OMTax',
  GH: 'GHTax',
  CM: 'CMTax',
  UZ: 'UZTax',
  FJ: 'FJTax',
  PF: 'PFTax',
  GT: 'GTTax',
  BS: 'BSTax',
  PH: 'PHTax',
  MX: 'MXTax',
  LA: 'LATax',
  ZA: 'ZATax',
  NP: 'NPTax',
  KZ: 'KZTax',
  GF: 'GFTax',
  BB: 'BBTax',
  AM: 'AMTax',
  AR: 'ARTax',
  AZ: 'AZTax',
  BJ: 'BJTax',
  CN: 'CNTax',
  YT: 'YTTax',
  CI: 'CITax',
  JP: 'JPTax',
  MY: 'MYTax',
  MM: 'MMTax',
  SR: 'SRTax',
  PM: 'PMTax',
  TJ: 'TJTax',
  UA: 'UATax',
  WF: 'WFTax',
  VE: 'VETax',
  ZM: 'ZMTax',
  LK: 'LKTax',
  CA: 'CATax',
  ReverseChargeDocument: 'ReverseChargeDocument',
  ReverseChargeDocumentTemplate: 'ReverseChargeDocumentTemplate',
  'US-AK': 'AlaskaTax',
  'US-HI': 'HawaiiTax',
  'US-AZ': 'USAZTax',
  'US-CA': 'USCATax',
  'US-CT': 'USCTTax',
  'US-MA': 'USMATax',
  'US-MD': 'USMDTax',
  'US-NJ': 'USNJTax',
  'US-NY': 'USNYTax',
  'US-OH': 'USOHTax',
  'US-PA': 'USPATax',
  'US-TX': 'USTXTax',
  'US-WA': 'USWATax',
};

export const ApiFileUrlBuilderName = 'ApiFileUrlBuilder';

export const GlobalTaxIdHelpPopUpId = 'pop_BA_Accounts_TaxRegistrationID';

export const GlobalFilePickerRequiredErrorMessage = _TL_('Please upload your tax certificate document associated with your {{taxId}}.');

export const DeclineReasonTypesI18nMapping = {
  [TaxCertificateDeclineReasonType.SubmittedDocumentInvalid]: _TL_('Document submitted is not the Formulario del Registro Unico Tributario Hoja Principal.'),
  [TaxCertificateDeclineReasonType.CodigoSectionInvalid]: _TL_('None of the fields in section 53 “Cόdigo” contain an 11 or a 48.'),
  [TaxCertificateDeclineReasonType.NITMissingOrIncomplete]: _TL_('The NIT is missing or incomplete.'),
  [TaxCertificateDeclineReasonType.NITMismatch]: _TL_('The NIT number on the certificate does not match the number entered into the Microsoft advertising portal.'),
};

const globalTaxFeatures = [
  'ABLEgyptTax',
  'ABLEgyptTaxUpdate',
  'ABLGlobalPhase2NonZA',
  'ABLProjectEmeraldTaxCollection',
  'ABLGlobalPhase2ZA',
  'ABLGlobalPhase3',
  'ABLGlobalTaxAEBHKHKE',
  'RemoteSellerEnablementTaxIdCollection',
  'ABLGlobalTaxBYNGISMDZW',
  'ABLGlobalTaxGETHBDID',
  'ABLGlobalTaxILNOTRVN',
  'ABLGlobalTaxSAOMGHCM',
  'ABLGlobalTaxUZFJGTBSPH',
  'ABLGlobalPhase4',
  'ABLBrazilUpdateTax',
  'ABLSenegalTax',
  'ABLTaiwanTax',
  'ABLSriLankaTax',
  'ABLGlobalTaxIdEnablementBatch1',
];

const features = _.union([
  'ABLAlaskaTax',
  'ABLCanadaTax',
  'ABLChileTax',
  'ABLColombiaTax',
  'ABLHawaiiTax',
  'ABLHungaryTax',
  'ABLLegalIdentifierNumber',
  'ABLPortugalTax',
  'ABLUSTaxCertPhase1',
  'SerbiaEInvoicing',
  'ABLBrazilUpdateTax',
  'ABLGlobalTaxPHTaxApproval',
  'ABLReunionTax',
  'ABLBrazilNewCCMTax',
  'ABLBrazilNewCNPJ',
  'ABLBrazilCPFMandatory',
  'XandrCanadaTaxCertificate',
], globalTaxFeatures);

export const GlobalTaxIdPilots = _.object(globalTaxFeatures, globalTaxFeatures);

/**
 * The names of the required features for the tax form component.
 * Any features not listed here should *not* be expected to be passed in
 * through the permissions object by the host components.
 * The returned object is a map where each entry has the key identical to the value,
 * both representing the name of a required feature.
 */
export const requiredFeatures = _.object(features, features);

export const LegalIdentifierNumberPilot = requiredFeatures.ABLLegalIdentifierNumber;
export const SerbiaEInvoicingPilot = requiredFeatures.SerbiaEInvoicing;

export const GlobalTaxIdCountryCodeToPilots = {
  IL: GlobalTaxIdPilots.ABLGlobalTaxILNOTRVN,
  NO: GlobalTaxIdPilots.ABLGlobalTaxILNOTRVN,
  TR: GlobalTaxIdPilots.ABLGlobalTaxILNOTRVN,
  VN: GlobalTaxIdPilots.ABLGlobalTaxILNOTRVN,
  GE: GlobalTaxIdPilots.ABLGlobalTaxGETHBDID,
  TH: GlobalTaxIdPilots.ABLGlobalTaxGETHBDID,
  BD: GlobalTaxIdPilots.ABLGlobalTaxGETHBDID,
  ID: GlobalTaxIdPilots.ABLGlobalTaxGETHBDID,
  BY: GlobalTaxIdPilots.ABLGlobalTaxBYNGISMDZW,
  NG: GlobalTaxIdPilots.ABLGlobalTaxBYNGISMDZW,
  IS: GlobalTaxIdPilots.ABLGlobalTaxBYNGISMDZW,
  MD: GlobalTaxIdPilots.ABLGlobalTaxBYNGISMDZW,
  WF: GlobalTaxIdPilots.ABLProjectEmeraldTaxCollection,
  ZW: GlobalTaxIdPilots.ABLGlobalTaxBYNGISMDZW,
  AE: GlobalTaxIdPilots.ABLGlobalTaxAEBHKHKE,
  BH: GlobalTaxIdPilots.ABLGlobalTaxAEBHKHKE,
  KH: GlobalTaxIdPilots.ABLGlobalTaxAEBHKHKE,
  NC: GlobalTaxIdPilots.ABLProjectEmeraldTaxCollection,
  KE: GlobalTaxIdPilots.ABLGlobalTaxAEBHKHKE,
  SA: GlobalTaxIdPilots.ABLGlobalTaxSAOMGHCM,
  YT: GlobalTaxIdPilots.ABLProjectEmeraldTaxCollection,
  AL: GlobalTaxIdPilots.RemoteSellerEnablementTaxIdCollection,
  SZ: GlobalTaxIdPilots.RemoteSellerEnablementTaxIdCollection,
  KG: GlobalTaxIdPilots.RemoteSellerEnablementTaxIdCollection,
  TZ: GlobalTaxIdPilots.RemoteSellerEnablementTaxIdCollection,
  OM: GlobalTaxIdPilots.ABLGlobalTaxSAOMGHCM,
  GH: GlobalTaxIdPilots.ABLGlobalTaxSAOMGHCM,
  CM: GlobalTaxIdPilots.ABLGlobalTaxSAOMGHCM,
  UZ: GlobalTaxIdPilots.ABLGlobalTaxUZFJGTBSPH,
  FJ: GlobalTaxIdPilots.ABLGlobalTaxUZFJGTBSPH,
  GF: GlobalTaxIdPilots.ABLProjectEmeraldTaxCollection,
  GT: GlobalTaxIdPilots.ABLGlobalTaxUZFJGTBSPH,
  BS: GlobalTaxIdPilots.ABLGlobalTaxUZFJGTBSPH,
  PM: GlobalTaxIdPilots.ABLProjectEmeraldTaxCollection,
  PH: GlobalTaxIdPilots.ABLGlobalTaxUZFJGTBSPH,
  AM: GlobalTaxIdPilots.ABLGlobalPhase2NonZA,
  BB: GlobalTaxIdPilots.ABLGlobalPhase2NonZA,
  KZ: GlobalTaxIdPilots.ABLGlobalPhase2NonZA,
  MX: GlobalTaxIdPilots.ABLGlobalPhase2NonZA,
  ZA: GlobalTaxIdPilots.ABLGlobalPhase2ZA,
  LA: GlobalTaxIdPilots.ABLGlobalPhase2NonZA,
  NP: GlobalTaxIdPilots.ABLGlobalPhase2NonZA,
  AR: GlobalTaxIdPilots.ABLGlobalPhase3,
  PF: GlobalTaxIdPilots.ABLProjectEmeraldTaxCollection,
  AZ: GlobalTaxIdPilots.ABLGlobalPhase3,
  BJ: GlobalTaxIdPilots.ABLGlobalPhase3,
  CN: GlobalTaxIdPilots.ABLGlobalPhase3,
  CI: GlobalTaxIdPilots.ABLGlobalPhase3,
  JP: GlobalTaxIdPilots.ABLGlobalPhase3,
  MY: GlobalTaxIdPilots.ABLGlobalPhase3,
  MM: GlobalTaxIdPilots.ABLGlobalPhase3,
  SR: GlobalTaxIdPilots.ABLGlobalPhase3,
  TJ: GlobalTaxIdPilots.ABLGlobalPhase3,
  UA: GlobalTaxIdPilots.ABLGlobalPhase3,
  VE: GlobalTaxIdPilots.ABLGlobalPhase3,
  ZM: GlobalTaxIdPilots.ABLGlobalPhase3,
  EG: GlobalTaxIdPilots.ABLEgyptTax,
  KR: GlobalTaxIdPilots.ABLGlobalPhase4,
  PE: GlobalTaxIdPilots.ABLGlobalPhase4,
  UY: GlobalTaxIdPilots.ABLGlobalPhase4,
  PA: GlobalTaxIdPilots.ABLGlobalPhase4,
  PK: GlobalTaxIdPilots.ABLGlobalPhase4,
  SN: GlobalTaxIdPilots.ABLSenegalTax,
  TW: GlobalTaxIdPilots.ABLTaiwanTax,
  LK: GlobalTaxIdPilots.ABLSriLankaTax,
  DZ: GlobalTaxIdPilots.ABLGlobalTaxIdEnablementBatch1,
  AO: GlobalTaxIdPilots.ABLGlobalTaxIdEnablementBatch1,
  BA: GlobalTaxIdPilots.ABLGlobalTaxIdEnablementBatch1,
  BW: GlobalTaxIdPilots.ABLGlobalTaxIdEnablementBatch1,
  MU: GlobalTaxIdPilots.ABLGlobalTaxIdEnablementBatch1,
  MA: GlobalTaxIdPilots.ABLGlobalTaxIdEnablementBatch1,
  MZ: GlobalTaxIdPilots.ABLGlobalTaxIdEnablementBatch1,
  MK: GlobalTaxIdPilots.ABLGlobalTaxIdEnablementBatch1,
  UG: GlobalTaxIdPilots.ABLGlobalTaxIdEnablementBatch1,
};

export const LegalIdentifierHintI18nKey = {
  AM: _TL_('Please provide your UNN/Public service number.'),
  AZ: _TL_('Please provide your TIN/INN/PIC.'),
  BR: _TL_('Please provide your CPF.'),
  CN: _TL_('Please provide your TIN.'),
  HU: _TL_('Please provide your TIN.'),
  IN: _TL_('Please provide your TIN/PAN.'),
  IQ: _TL_('Please provide your TIN.'),
  KZ: _TL_('Please provide your BIN/IIN.'),
  KG: _TL_('Please provide your INN.'),
  MD: _TL_('Please provide your IDNO/IDNP/Fiscal Code.'),
  MM: _TL_('Please provide your TIN.'),
  PL: _TL_('Please provide your TIN/PESEL.'),
  RU: _TL_('Please provide your INN.'),
  SA: _TL_('Please provide your TIN.'),
  ZA: _TL_('Please provide your TRN.'),
  SS: _TL_('Please provide your TIN.'),
  TJ: _TL_('Please provide your INN/EIN/KPP.'),
  TH: _TL_('Please provide your TIN.'),
  TR: _TL_('Please provide your TIN.'),
  UA: _TL_('Please provide your EGRPOU/EDRPOU.'),
  AE: _TL_('Please provide your 5 Digits Commercial License number or 15 Digits VAT TRN.'),
  UZ: _TL_('Please provide your INN.'),
  VE: _TL_('Please provide your RIF.'),
  VN: _TL_('Please provide your TIN.'),
  BD: _TL_('Please provide your PAN.'),
  BT: _TL_('Please provide your TPN.'),
  NP: _TL_('Please provide your PAN.'),
  PK: _TL_('Please provide your NTN.'),
  LK: _TL_('Please provide your TIN.'),
  MV: _TL_('Please provide your TIN.'),
};

export const USTaxCertPhase0States = [
  'AK',
  'HI',
];

export const USTaxCertPhase1States = [
  'MD',
  'MA',
  'NY',
  'OH',
  'PA',
  'WA',
  'AZ',
  'CA',
  'CT',
  'NJ',
  'TX',
];

export const USTaxCertStates = _.object(USTaxCertPhase0States.concat(USTaxCertPhase1States), USTaxCertPhase0States.concat(USTaxCertPhase1States));

export const VatStatusI18nMap = {
  [VatStatusEnum.Valid]: _TL_('Valid'),
  [VatStatusEnum.Invalid]: _TL_('Invalid'),
  [VatStatusEnum.Pending]: _TL_('Pending'),
  [VatStatusEnum.PastDue]: _TL_('Past due'),
};

export const TaxCertificationStatusInfoI18nMap = {
  [VatStatusEnum.Valid]: _TL_('Your tax certificate has been approved.'),
  [VatStatusEnum.Invalid]: _TL_('Your tax certificate has been rejected.'),
  [VatStatusEnum.Pending]: _TL_('Your tax certificate is pending for review.'),
};
